export default "__VITE_ASSET__BsMH8aFv__"